import { SmsTemplate } from "./types";

/* global Office */
const STORAGE_KEY = "lox24Templates";

export function loadTemplates(): SmsTemplate[] {
  const stored = Office.context.roamingSettings.get(STORAGE_KEY) as SmsTemplate[] | undefined;
  return Array.isArray(stored) ? stored : [];
}

export function saveTemplates(templates: SmsTemplate[]): Promise<void> {
  Office.context.roamingSettings.set(STORAGE_KEY, templates);
  return new Promise((resolve, reject) => {
    Office.context.roamingSettings.saveAsync((result) => {
      if (result.status === Office.AsyncResultStatus.Succeeded) {
        resolve();
      } else {
        reject(result.error);
      }
    });
  });
}
